var _path, _path2, _rect, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvg = function SvgSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    fillRule: "evenodd",
    d: "m18.75 24.012-2.25 2.25 2.25 2.25 1.523-1.524h4.597q.035.103.08.201c-2.222.44-4.285 1.586-5.905 3.314-2.11 2.25-3.295 5.303-3.295 8.485h3c.003-2.382.872-4.667 2.416-6.352C22.713 30.948 24.812 30 27 30s4.287.948 5.834 2.636c1.544 1.685 2.413 3.97 2.416 6.352h3c0-3.182-1.185-6.235-3.295-8.485-1.62-1.728-3.683-2.875-5.904-3.314q.045-.098.08-.2h4.596l1.523 1.523 2.25-2.25-2.25-2.25-1.477 1.476h-4.66a2.25 2.25 0 0 0-4.226 0h-4.66z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#995508",
    rx: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.344 13.875a.63.63 0 0 0-.22-.457q-.193-.164-.589-.164-.252 0-.413.061a.5.5 0 0 0-.234.162.4.4 0 0 0-.08.234.4.4 0 0 0 .039.196q.046.086.146.155.099.068.255.123.154.056.37.1l.491.106q.499.105.853.278.354.172.58.407.225.231.33.522.11.29.112.632-.002.593-.296 1.002-.292.411-.838.624-.54.214-1.303.214-.783 0-1.365-.231a1.9 1.9 0 0 1-.903-.712q-.32-.483-.322-1.236h1.547q.014.275.137.463t.346.284q.226.096.536.096.261 0 .437-.064a.6.6 0 0 0 .266-.179.42.42 0 0 0 .094-.26.37.37 0 0 0-.09-.24.7.7 0 0 0-.282-.188 3 3 0 0 0-.53-.159l-.598-.128q-.797-.174-1.257-.578-.457-.406-.454-1.11-.003-.57.305-.999a2.04 2.04 0 0 1 .858-.67 3.1 3.1 0 0 1 1.263-.241q.726 0 1.257.243t.817.686q.29.439.293 1.028zm3.9-1.875 1.231 4.23h.047l1.23-4.23h1.84l-1.98 6h-2.227l-1.98-6zm8.444 1.98a.8.8 0 0 0-.12-.272.84.84 0 0 0-.486-.328 1.3 1.3 0 0 0-.35-.044 1.2 1.2 0 0 0-.7.196q-.285.197-.439.566-.15.37-.15.89 0 .528.144.903t.428.574.706.2q.372 0 .618-.11a.8.8 0 0 0 .372-.307.87.87 0 0 0 .123-.469l.282.03h-1.372v-1.16h2.66v.832q0 .82-.348 1.403-.345.58-.955.89-.606.308-1.392.308-.875 0-1.538-.372a2.6 2.6 0 0 1-1.034-1.06q-.37-.69-.37-1.638 0-.744.227-1.319.228-.574.632-.97.404-.397.935-.6a3.1 3.1 0 0 1 1.137-.205q.532 0 .99.152.46.15.811.428.355.275.572.653t.263.83z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgSvg;